import * as React from 'react';
import { SummaryDesktop } from './Summary.desktop';
import { withProvider } from '../../redux';
import { ApplicationContext } from '../ApplicationContext';
import { ISummaryContainerProps } from './types';
import { useSelector } from 'react-redux';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../selectors/publishAvailable';
import { NeedIdentification } from '../NeedIdentification';
import { HiddenBaseContainer } from '../HiddenBase';
import { Device } from '../common/Device';
import { SummaryMobile } from './Summary.mobile';
import { selectIsAutoProlongAvailable } from '../../selectors/checkoutInfo';

export const Container = () => {
  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);
  const isAutoProlongAvailable = useSelector(selectIsAutoProlongAvailable);

  if (isIdentificationNeeded) {
    return <NeedIdentification />;
  }

  if (isPublishToHiddenBase) {
    return <HiddenBaseContainer />;
  }

  return (
    <Device mobile={<SummaryMobile isAutoProlongVisible={isAutoProlongAvailable} />} desktop={<SummaryDesktop />} />
  );
};

export const SummaryContainer = withProvider(
  ({ httpApi, logger, config, telemetry, microfrontend, microfrontendsApi }: ISummaryContainerProps) => {
    const context = React.useMemo(
      () => ({ httpApi, logger, config, telemetry, microfrontend, microfrontendsApi }),
      [httpApi, logger, config, telemetry, microfrontend, microfrontendsApi],
    );

    return (
      <ApplicationContext.Provider value={context}>
        <Container />
      </ApplicationContext.Provider>
    );
  },
);
